import { useMutation, useQueryClient } from '@tanstack/react-query';
import { isArray } from 'lodash';

import { useLoader } from 'Store/loader';
import { useToast } from 'Store/toast';
import { postPresenceClockOutText } from 'Const/monitoring/domain';
import postPresenceClockOut from 'Api/monitoring/postPresenceClockOut';

import postPresenceClockOutPayload from './model/request/postPresenceClockOutPayload';

const usePostPresenceClockOut = () => {
  const { onShowLoader, onResetLoader } = useLoader();
  const { onOpenToast } = useToast();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (formData) => {
      onShowLoader({ variant: 'loader-primary' });

      const payload = postPresenceClockOutPayload(formData);

      const response = await postPresenceClockOut(payload);

      return response;
    },
    onSuccess: (response) => {
      const time = response?.operatorPresence?.clockOutTime;
      const isViolation = response?.operatorPresence?.isViolatedClockOut;

      queryClient.invalidateQueries({ queryKey: ['monitoring-operator-status'] });

      if (isViolation) {
        const description = postPresenceClockOutText.getPresenceClockOutViolation(time);
        return onOpenToast({
          status: 'error',
          description,
          duration: 5,
          alwaysShow: false,
        });
      }

      const description = postPresenceClockOutText.getOnTimePresenceClockOutText(time);

      return onOpenToast({ status: 'success', description, duration: 5, alwaysShow: false });
    },
    onError: (error) => {
      const errorMessage = isArray(error?.response?.data?.errors)
        ? error?.response?.data?.errors[0]?.message
        : postPresenceClockOutText.defaultErrorMessageText;

      onOpenToast({ status: 'error', description: errorMessage, duration: 5, alwaysShow: false });
    },
    onSettled: () => onResetLoader(),
  });
};

export default usePostPresenceClockOut;
